module.exports = __webpack_public_path__ + "img/10x2.ac2871bb.png";